import {useMutation, UseMutationResult, useQueryClient} from "@tanstack/react-query";
import {ITask} from "../../../../../../../utils/interfaces/my_projects/ITask";
import {CustomAxiosError, useApiCalls} from "../../../../../../../logics/api_config";
import {useAuth} from "../../../../../../../utils/contexts/auth-context";


const useApiUpdateTask = (): UseMutationResult<ITask, CustomAxiosError, {
    id: number;
    data: any
}, unknown> => {
    const queryClient = useQueryClient();
    const {selectedCompany} = useAuth()

    const {put} = useApiCalls()


    async function doUpdate(company_token: string | undefined,
                            pk: number | undefined,
                            data: any): Promise<ITask> {
        try {
            const response = await put(`/api/company/${company_token}/my_projects/tasks/${pk}`, data);
            return response.data as ITask;
        } catch (error) {
            throw error;
        }
    }

    return useMutation<ITask, CustomAxiosError, {
        id: number;
        data: any
    }, unknown>({
        mutationFn: async ({id, data}) => {
            return await doUpdate(selectedCompany?.company_token, id, data);
        },

    });
};


export default useApiUpdateTask;